import React from 'react';
import NavbarComponent from '../pages/Navbar'; // ✅ fixed path
import Footer from '../Footer'; 
import ServiceBanner from "../Servicepage/ServiceBanner"
import ServiceSection from "../Servicepage/ServiceSection"
const Services = () => {
  return (
    <>
      <NavbarComponent />
     <ServiceBanner/>
     <ServiceSection/>
       
      <Footer />
    </>
  );
};

export default Services;
